export const WORD_CARDS = [
  {
    id: 1,
    value: "apple",
    type: "word",
  },
  {
    id: 2,
    value: "banana",
    type: "word",
  },
  {
    id: 3,
    value: "blackberry",
    type: "word",
  },
  {
    id: 4,
    value: "carrot",
    type: "word",
  },
  {
    id: 5,
    value: "cherry",
    type: "word",
  },
  {
    id: 6,
    value: "cucumber",
    type: "word",
  },
  {
    id: 7,
    value: "eggplant",
    type: "word",
  },
  {
    id: 8,
    value: "grape",
    type: "word",
  },
  {
    id: 9,
    value: "kiwi",
    type: "word",
  },
  {
    id: 10,
    value: "lemon",
    type: "word",
  },
  {
    id: 11,
    value: "onion",
    type: "word",
  },
  {
    id: 12,
    value: "orange",
    type: "word",
  },
  {
    id: 13,
    value: "pear",
    type: "word",
  },
  {
    id: 14,
    value: "pineapple",
    type: "word",
  },
  {
    id: 15,
    value: "pomegranate",
    type: "word",
  },
  {
    id: 16,
    value: "potato",
    type: "word",
  },
  {
    id: 17,
    value: "raspberry",
    type: "word",
  },
  {
    id: 18,
    value: "strawberry",
    type: "word",
  },
  {
    id: 19,
    value: "tomato",
    type: "word",
  },
  {
    id: 20,
    value: "watermelon",
    type: "word",
  },
];
